/**
 * Преобразует объект изменений в массив объектов с id и новыми значениями.
 * Значения будут автоматически преобразованы в число, если это возможно,
 * за исключением определённых полей, которые всегда остаются строками.
 *
 * @param {Object} changes - Объект с изменениями, где ключи — это ID, а значения — объект с полями изменений.
 * @returns {Array<Object>} - Массив объектов, каждый из которых содержит:
 *   - id: идентификатор элемента
 *   - ключи: изменённые поля и их новые значения (числа или строки, в зависимости от типа)
 */
function extractNewValuesById(changes) {
  // Список полей, которые не нужно преобразовывать в числа
  const skipParseFields = new Set(['object', 'railChainName']);

  return Object.entries(changes).reduce((acc, [id, fields]) => {
    // Инициализируем объект для текущего элемента, преобразуем id в число, если возможно
    const entry = { id: isNaN(id) ? id : Number(id) };
    let hasChanges = false;

    // Перебираем все поля, относящиеся к текущему ID
    for (const [key, value] of Object.entries(fields)) {
      // Пропускаем служебную метаинформацию
      if (key === 'meta') continue;

      // Проверяем, есть ли новое значение у поля
      if (value && 'new' in value) {
        let newVal = value.new;

        /**
         * Преобразуем значение к числу только если:
         * - поле не в списке исключений
         * - значение не null
         * - значение является строкой, не пустой и числовой
         */
        if (
          !skipParseFields.has(key) &&
          newVal !== null &&
          typeof newVal === 'string' &&
          newVal.trim() !== '' &&
          !isNaN(newVal)
        ) {
          newVal = Number(newVal);
        }

        // Записываем новое значение в результирующий объект
        entry[key] = newVal;
        hasChanges = true;
      }
    }

    // Добавляем объект только если были реальные изменения
    if (hasChanges) {
      acc.push(entry);
    }

    return acc;
  }, []);
}

export default extractNewValuesById;
